import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import TaskCard from './TaskCard';

const CalendarDay = ({ day, tasks, onTaskDrop, isToday, isPast, scheduledTaskIds }) => {
    const [isOver, setIsOver] = useState(false);

    // Native drop handlers
    const handleDragOver = (e) => {
        if (isPast) return
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setIsOver(true);
    };

    const handleDragLeave = (e) => {
        // setIsOver(false);
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsOver(false);
        }
    };

    const handleDrop = (e) => {
        if (isPast) return
        e.preventDefault();
        setIsOver(false);

        const taskId = parseInt(e.dataTransfer.getData('taskId'));
        if (taskId) {
            onTaskDrop(taskId, day);
        }
    };

    return (
        <Box
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            sx={{
                borderRight: '1px solid #E5E7EB',
                // backgroundColor: isOver ? '#EFF6FF' : isToday ? '#FEF3C7' : '#FFFFFF',
                // backgroundColor: '#ffffff',
                backgroundColor: isPast
                    ? '#F3F4F6'
                    : isOver
                        ? '#ffffff'
                        : '#ffffff',
                cursor: isPast ? 'not-allowed' : 'default', // ← show not-allowed cursor
                opacity: isPast ? 0.6 : 1, // ← dim past date columns
                minHeight: '500px',
                display: 'flex',
                flexDirection: 'column',
                '&:last-child': {
                    borderRight: 'none'
                },
                transition: 'background-color 0.2s'
            }}
        >
            {/* Day Header */}
            <Box
                sx={{
                    p: 2,
                    gap: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    borderBottom: isToday ? '3px solid #2666be' : '1px solid #E5E7EB',
                    textAlign: 'center',
                    backgroundColor: isToday ? '#DBEAFE' : 'transparent'
                }}
            >
                {/* Day number */}
                <Typography
                    // variant="h6"
                    fontWeight={500}
                    sx={{
                        color: isToday ? '#2666be' : '#1F2937',
                        fontSize: '20px'
                    }}
                >
                    {format(day, 'd')}
                </Typography>

                {/* Day of week*/}
                <Typography
                    variant="body2"
                    sx={{
                        color: '#3a3a3a',
                        fontSize: '12px',
                        fontWeight: 400,
                        mb: 0.5
                    }}
                >
                    {format(day, 'EEE')}
                </Typography>

            </Box>

            {/* Tasks */}
            <Box sx={{ p: 1.5, flex: 1, overflowY: 'auto' }}>
                {tasks.map((task) => (
                    <Box key={task.id} sx={{ mb: 1.5 }}>
                        <TaskCard
                            task={task}
                            isInSidebar={false}
                            isInCalendar={scheduledTaskIds && scheduledTaskIds.has(task.id)}
                        />
                    </Box>
                ))}

                {/* Drop Zone Hint */}
                {isOver && tasks.length === 0 && (
                    <Box
                        sx={{
                            border: '2px dashed #2563EB',
                            borderRadius: 2,
                            p: 3,
                            textAlign: 'center',
                            backgroundColor: '#EFF6FF'
                        }}
                    >
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                Drop task here
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default CalendarDay;